import React from 'react';
import { CalendarEvent } from '../../types/calendar';
import { ExternalLink } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
interface EventPillProps {
  event: CalendarEvent;
  onClick?: (e: React.MouseEvent) => void;
}
export function EventPill({
  event,
  onClick
}: EventPillProps) {
  const navigate = useNavigate();
  const getStyles = () => {
    switch (event.type) {
      case 'Demo':
        return 'bg-growthly-green/20 text-growthly-green border-l-2 border-growthly-green';
      case 'Propuesta':
        return 'bg-growthly-amber/20 text-growthly-amber border-l-2 border-growthly-amber';
      case 'Cita':
        return 'bg-white/10 text-white border-l-2 border-white/40';
      case 'Cancelado':
        return 'bg-growthly-red/15 text-growthly-red line-through border-l-2 border-growthly-red/50';
      default:
        return 'bg-white/10 text-white border-l-2 border-white/40';
    }
  };
  const formatTime = (isoString: string) => {
    const date = new Date(isoString);
    return date.toLocaleTimeString('es-ES', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };
  const handleLinkClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigate(`/leads/${event.leadId}`);
  };
  return <div onClick={onClick} className={`flex items-center justify-between px-2 py-1 mb-1 rounded-r text-[11px] font-medium cursor-pointer hover:opacity-80 transition-opacity truncate ${getStyles()}`} title={`${event.title} (${formatTime(event.start)})`} data-id="element-143">
      <div className="flex items-center truncate" data-id="element-144">
        <span className="mr-1 opacity-80" data-id="element-145">{formatTime(event.start)}</span>
        <span className="truncate" data-id="element-146">{event.leadName}</span>
      </div>
      <ExternalLink className="w-3 h-3 ml-1 flex-shrink-0 opacity-50 hover:opacity-100" onClick={handleLinkClick} data-id="element-147" />
    </div>;
}